import SubscriptionWrapper from './subscription-wrapper';

function NetworkProvider() {
    const providers = {};
    const subscriptions = {};

    const getKey = (collection, identifier) => `${collection}_${identifier}`;

    this.add = (collection, provider) => {
        if (!collection) {
            throw new Error('First parameter to network.add should be a collection string');
        }
        if (!provider) {
            throw new Error('Second parameter to network.add should be a network provider');
        }
        if (!provider.fetch) {
            throw new Error('Second parameter provider is missing a fetch property');
        }

        providers[collection] = provider;
    };

    this.hasProvider = collection => !!providers[collection];

    this.fetch = (collection, identifier, callback) => {
        const provider = providers[collection];
        if (!provider) {
            callback(new Error(`No network provider found for ${collection}`));
            return;
        }
        provider.fetch(identifier, callback, { bypassQueue: true });
    };

    this.subscribe = (collection, identifier, versionTag, onSubscribe, onUpdate) => {
        const key = getKey(collection, identifier);
        let subscriptionWrapper = subscriptions[key];
        if (!subscriptionWrapper) {
            subscriptionWrapper = subscriptions[key] = new SubscriptionWrapper();
        }

        const provider = providers[collection];
        if (!provider) {
            onSubscribe(new Error(`No network provider found for ${collection}`));
            return;
        }

        if (subscriptionWrapper.subscription) {
            onSubscribe(new Error('Subscription already present'));
            return;
        }

        subscriptionWrapper.subscription = provider.subscribe(
            identifier,
            versionTag,
            onSubscribe,
            onUpdate,
            { bypassQueue: true }
        );
        subscriptionWrapper.increase();
    };

    this.subscribeMultiple = (collection, identifiers, versionTag, onSubscribe, onUpdate) => {

        const provider = providers[collection];
        if (!provider) {
            onSubscribe(new Error(`No network provider found for ${collection}`));
            return;
        }

        const subscriptionInfos = provider.subscribeMultiple(
            identifiers,
            versionTag,
            onSubscribe,
            onUpdate,
            { bypassQueue: true }
        );

        subscriptionInfos.forEach(subscriptionInfo => {
            const key = getKey(collection, subscriptionInfo.id);
            let subscriptionWrapper = subscriptions[key];
            if (!subscriptionWrapper) {
                subscriptionWrapper = subscriptions[key] = new SubscriptionWrapper();
            }
            if (subscriptionWrapper.subscription) {
                return;
            }
            subscriptionWrapper.subscription = subscriptionInfo;
            subscriptionWrapper.increase();
        })
    };

    this.hasNetworkSubscription = (collection, identifier) =>
        !!subscriptions[getKey(collection, identifier)];

    this.increaseNetworkSubscription = (collection, identifier) => {
        const subscription = subscriptions[getKey(collection, identifier)];
        if (subscription) {
            subscription.increase();
        }
    };

    this.decreaseNetworkSubscription = (collection, identifier) => {
        const key = getKey(collection, identifier);
        const subscription = subscriptions[key];
        if (subscription) {
            subscription.decrease();
            if (!subscription.subscription) {
                delete subscriptions[key];
            }
        }
    };

    this.instrumentation = () => ({
        __this__: true,
        __name__: 'Network Provider',

        getSubscriptionCount: (collection, identifier) => {
            const subscription = subscriptions[getKey(collection, identifier)];
            return subscription ? subscription.count : 0;
        },

        getProviders: () => providers,
    });
}

export default NetworkProvider;
